package app.nestbridge.feature.careteam.usecase

import app.nestbridge.feature.careteam.model.CareTeam
import app.nestbridge.feature.careteam.service.CareTeamService
import me.tatarka.inject.annotations.Inject

@Inject
class FindAllCareTeamsUseCase(
    private val careTeamService: CareTeamService,
) {
    suspend operator fun invoke(): List<CareTeam> = careTeamService.findAll()
}
